var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1229_1920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3842 14.0288C12.0611 14.7019 12.6972 15.3317 13.3303 15.9645C14.4354 17.0687 15.5376 18.1755 16.6443 19.2781C16.9072 19.5401 17.0513 19.8412 16.983 20.2145C16.9122 20.6006 16.6847 20.8701 16.3111 20.9934C15.9287 21.1192 15.5788 21.035 15.2931 20.753C14.6653 20.1341 14.0451 19.5072 13.4224 18.8828C12.0736 17.5311 10.7253 16.179 9.37692 14.8273C8.87499 14.3237 8.87499 13.7568 9.37317 13.259C11.3184 11.3158 13.2641 9.37309 15.2064 7.42701C15.4963 7.13668 15.8208 6.98006 16.2361 7.08003C16.9559 7.25372 17.2433 8.10805 16.7739 8.67955C16.7122 8.75453 16.6418 8.82201 16.5731 8.89074C14.9132 10.5498 13.2537 12.2089 11.5925 13.8668C11.5388 13.9201 11.4725 13.9609 11.3842 14.0288Z",
    fill: "#007AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1229_1920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.00303,
    height: 14,
    fill: "white",
    transform: "translate(9 7.05005)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.e5f6518249dc39124e619e73aaf030c3.svg";
export { ForwardRef as ReactComponent };